export const TEVREDENHEIDSMETER_CONSTANTS = {
    STARTSCHERM_URL_SEGMENT: '/a/startscherm/v2/web'
} as const;
